import { Button } from "reactstrap";
import { GiKey } from "react-icons/gi";
import { PiPianoKeys } from "react-icons/pi";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { QAPI_URL } from "../../constants/api.constants";

export default function TeacherModuleAnswersAndDocs({
  module,
  answersAvaliable,
}) {
  const handleOpenAnswers = () => {
    axios
      .get(
        `${API_BASE_URL}/Module/GetModuleAnswers?moduleId=${module.moduleId}`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL, "Facit", 'fullscreen="yes"');
      })
      .catch(async (error) => {
        let responseObj = await error.response.data.text();
        if (responseObj.trim() === "FileNotFound") {
          toast.warn(
            <FormattedMessage id="Error_Code_Module_Answers_FileNotFound" />,
            TOAST_CONFIG
          );
        } else {
          toast.warn(
            responseObj ? (
              responseObj
            ) : (
              <FormattedMessage id="GenericApiError" />
            )
          );
        }
      });
  };

  const handleOpenGy25ModuleAnswers = () => {
    axios
      .post("/Course/GetModuleAnswers", {
        qApiId: module.qApiId,
      })
      .then((response) => {
        if (response.data?.result) {
          const data = JSON.parse(response.data.result);
          const win = window.open(
            `${QAPI_URL}/RT/RT?mode=5&lng=sv`,
            "",
            `fullscreen=yes,width=${window.screen.width},height=${window.screen.height}`
          );
          setTimeout(() => {
            win.postMessage({ fun: "init", param: { Data: data } }, "*");
          }, 2000);
        }
      })
      .catch((err) => {
        toast.warn(err?.message);
      });
  };

  return (
    <Button
      outline
      size="sm"
      className="d-flex align-items-center"
      color={
        module.qApiId != null || answersAvaliable ? "primary" : "secondary"
      }
      style={{ cursor: "pointer" }}
      disabled={!answersAvaliable && module.qApiId == null}
      onClick={
        module.isGy25 && !module.isFinalExam
          ? handleOpenGy25ModuleAnswers
          : handleOpenAnswers
      }
    >
      {module.isGy25 && !module.isFinalExam ? (
        <PiPianoKeys size={14} className="me-1" />
      ) : (
        <GiKey size={14} className="me-1" />
      )}
      <FormattedMessage id="Answers" />
    </Button>
  );
}
